<template>
    <div class="side-by-side-image">
        <ThLink
            v-if="data.link"
            v-qa="'slide-link'"
            v-bind="buttonBind"
            class="link"
            @click="scrollOnLinkFollow"
        >
            <CmsImage
                :data="data.image"
                fit="cover"
                :is-eager="isEager"
            />
        </ThLink>

        <CmsImage
            v-else
            :data="data.image"
            fit="cover"
            :is-eager="isEager"
        />

        <div
            v-if="data.caption"
            data-qa="caption"
            class="caption"
        >
            {{ data.caption }}
        </div>

        <div
            v-if="data.content"
            v-qa="'content'"
            class="content"
        >
            <ContentComponentItem
                v-for="(component, key) in data.content"
                :key="key"
                :data="component"
                @click="scrollOnLinkFollow"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue'

import type { ComponentSideBySideImageFragment } from '@/graphql/api'

import { useCmsLink } from '@/components/cms'
import { useScrollIntoView } from '@/views/product/composables/ui/useScrollIntoView'

import CmsImage from '@/components/cms/CmsImage.vue'
import ThLink from '@/components/ui/buttons/ThLink.vue'
import ContentComponentItem from '@/components/cms/component/ContentComponentItem.vue'
import { useRoute } from 'vue-router'
import { ROUTE_PAGE } from '@/router'

const props = defineProps<{
    data: ComponentSideBySideImageFragment
    isEager?: boolean
}>()

const buttonBind = useCmsLink(toRef(() => props.data.link))

const { scrollIntoView } = useScrollIntoView('.main', {
    top: 300,
    left: 0,
})

const route = useRoute()

const scrollOnLinkFollow = () => {
    // Make sure it only scrolls in PLP
    if (route.name === ROUTE_PAGE) {
        return
    }

    scrollIntoView()
}
</script>

<style lang="scss" scoped>
.side-by-side-image {
    width: 100%;
    line-height: 0;
    position: relative;

    .link {
        display: block;
        aspect-ratio: 1 / 1;
    }

    .caption {
        color: $slate;
        font-size: 0.875rem;
        line-height: 1.25rem;
        padding: 10px 30px 10px 0;
    }

    .content {
        padding: 10px 30px 10px 0;
    }
}
</style>
